import React from 'react';
import Tours from './Tours';
import { tours } from '../data';
import { Title } from '../components';

const newTours = tours.slice(6);

const New = () => {
  return (
    <>
      <section className="section bg-amber-50 " id="new">
      {/* <section className="section bg-blue-100 " id="featured"> */}
        <Title title="new tours" />
        <div className="section-center  rounded-3xl">
          <Tours tours={newTours} color="gray" extraCol />
        </div>
      </section>
    </>
  );
};

export default New;
